export var UNEXPECTED_ERROR_MESSAGE = 'Unexpected error occurred';
export var UNEXPECTED_NETWORK_ERROR_MESSAGE = 'Network error occurred, event batch rejected';
export var MAX_RETRIES_EXCEEDED_MESSAGE = 'Session replay event batch rejected due to exceeded retry count';
export var STORAGE_FAILURE = 'Failed to store session replay events in IndexedDB';
export var MISSING_DEVICE_ID_MESSAGE = 'Session replay event batch not sent due to missing device ID';
export var MISSING_API_KEY_MESSAGE = 'Session replay event batch not sent due to missing api key';